import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../../firebase';

export interface UserProfile {
  uid: string;
  email: string;
  displayName: string;
  photoURL: string | null;
}

const USERS_COLLECTION = 'users';

let usersCache: UserProfile[] | null = null;
let cacheTimestamp = 0;
const CACHE_TTL = 5 * 60 * 1000;

async function getAllUsers(): Promise<UserProfile[]> {
  if (usersCache && Date.now() - cacheTimestamp < CACHE_TTL) {
    return usersCache;
  }
  const snap = await getDocs(collection(db, USERS_COLLECTION));
  usersCache = snap.docs.map(d => d.data() as UserProfile);
  cacheTimestamp = Date.now();
  return usersCache;
}

export async function searchUserProfiles(searchTerm: string, maxResults = 8): Promise<UserProfile[]> {
  const allUsers = await getAllUsers();
  if (!searchTerm.trim()) return allUsers.slice(0, maxResults);
  const term = searchTerm.toLowerCase();
  return allUsers
    .filter(u =>
      u.displayName.toLowerCase().includes(term) ||
      u.email.toLowerCase().includes(term),
    )
    .slice(0, maxResults);
}
